import { render, staticRenderFns } from "./palm1.vue?vue&type=template&id=1f6e5874&scoped=true&"
import script from "./palm1.vue?vue&type=script&lang=js&"
export * from "./palm1.vue?vue&type=script&lang=js&"
import style0 from "./palm1.vue?vue&type=style&index=0&id=1f6e5874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e5874",
  null
  
)

export default component.exports